var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin div100"> <div id="module_margin" class="div100"> <div id="pictureSingle" class="div100"> <div id="content" class="div100"> <div class="skitter-large-box div100" style=""> <div class="skitter skitter-large with-dots div100" style=""> <div id="pictureSingleList"></div> </div> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
